import { all, fork, put, takeEvery } from 'redux-saga/effects';
import * as types from './types';
import * as Api from '../../api/preProcessedDocuments';
import callToAPI from '../../../utils/callToAPI';
import PreProcessedDocument from '../../../models/PreProcessedDocument';

function* getPreProcessedDocuments({ payload }) {
  yield callToAPI({
    apiCall: Api.getPreProcessedDocuments,
    successResponseCode: 200,
    errorType: types.GET_PRE_PROCESSED_DOCUMENTS_ERROR,
    *callback(response) {
      yield put({
        type: types.GET_PRE_PROCESSED_DOCUMENTS_SUCCESS,
        payload: {
          preProcessedDocuments: response.data.data.map(
            (preProcessedDocument) => {
              return new PreProcessedDocument(preProcessedDocument);
            },
          ),
          total: response.data.total,
        },
      });
    },
    payload,
  });
}

function* deletePreProcessedDocument({ payload }) {
  yield callToAPI({
    apiCall: Api.deletePreProcessedDocument,
    successResponseCode: 200,
    errorType: types.DELETE_PRE_PROCESSED_DOCUMENT_ERROR,
    *callback() {
      yield put({ type: types.DELETE_PRE_PROCESSED_DOCUMENT_SUCCESS, payload });
    },
    payload,
  });
}

/* watchers */
function* watcherGetPreProcessedDocuments() {
  yield takeEvery(
    types.GET_PRE_PROCESSED_DOCUMENTS_REQUEST,
    getPreProcessedDocuments,
  );
}

function* watcherDeletePreProcessedDocument() {
  yield takeEvery(
    types.DELETE_PRE_PROCESSED_DOCUMENT_REQUEST,
    deletePreProcessedDocument,
  );
}

export default function* rootSaga() {
  yield all([
    fork(watcherGetPreProcessedDocuments),
    fork(watcherDeletePreProcessedDocument),
  ]);
}
